<template>
    <div class="namelist-content">
        <div :class="{ 'names-checkbox-wrapper':true, 'hasBegun':hasBegun }">
            <!-- * Namen zijn momenteel hard-coded, zullen later uit een DB komen. () => Filter op namen A-Z, dubbele namen enkel de achterletter er van. -->

            <!-- We retrieve the index of the array, which gives us an type of "person ID", which we use to make the labels work etc. -->
            <div class="names-checkbox-wrapper-item" v-for="(person, index) in retrievedPersons" :key="index">
                <input
                    type="checkbox"
                    :id="'person-' + index"
                    @click="togglePresence( person )"
                    @focus="checkboxFocusHandler( $event )"
                    :checked="person.presence">
                <label :for="'person-' + index" :class="{ 'checked-person': person.alreadySpoken === true }">{{ person.name }} <span v-if="person.flaggedDouble && person.surname">{{ person.surname.charAt(0) }}.</span></label>
                <button class="round" @click="deletePerson(person)">+</button>
            </div>
        </div>
    </div>
</template>

<style lang="scss"></style>

<script>
    export default {
        name: 'PersonList',

        components: {
        },

        computed: {
            retrievedPersons()
            {
                let retrievedPersons = this.$store.getters['people/getPersons'];

                // Function from: Wogan - https://stackoverflow.com/questions/1129216/sort-array-of-objects-by-string-property-value
                retrievedPersons.sort( ( a, b ) => ( a.name > b.name ) ? 1 : ( ( b.name > a.name ) ? -1 : 0 ) );

                return retrievedPersons;
            },

            hasBegun()
            {
                return this.$store.getters.hasBegun;
            }
        },

        methods: {
            togglePresence( person )
            {
                this.$store.dispatch( 'people/togglePresence', person );
            },

            deletePerson( person )
            {
                this.$store.dispatch( 'people/deletePerson', person );
            },

            checkboxFocusHandler( event )
            {
                event.target.blur();
            }
        }
    };
</script>
